export default "/icons/css3-alt.svg";